var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87501 1.87498C7.95946 1.83335 11.0428 1.87501 14.125 1.99998C16 3.87498 17.875 5.74998 19.75 7.62498C19.8749 9.70666 19.9166 11.79 19.875 13.875C19.2083 13.875 18.5417 13.875 17.875 13.875C17.875 12.2083 17.875 10.5417 17.875 8.87498C16.2083 8.87498 14.5417 8.87498 12.875 8.87498C12.875 7.20831 12.875 5.54166 12.875 3.87498C10.5417 3.87498 8.20833 3.87498 5.87501 3.87498C5.87501 9.20831 5.87501 14.5417 5.87501 19.875C8.04328 19.8334 10.2099 19.875 12.375 20C12.9583 20.5833 13.5417 21.1667 14.125 21.75C11.0417 21.9167 7.95833 21.9167 4.87501 21.75C4.41668 21.625 4.12501 21.3333 4.00001 20.875C3.83333 14.875 3.83333 8.87498 4.00001 2.87498C4.17243 2.41242 4.46411 2.07909 4.87501 1.87498Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.847,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8753 8.87522C11.5915 8.76392 12.2165 8.9306 12.7503 9.37522C12.8324 10.6314 12.8324 11.8814 12.7503 13.1252C12.8666 13.4829 13.075 13.7746 13.3753 14.0002C14.1396 14.0643 14.8896 14.1893 15.6253 14.3752C16.1768 15.8643 15.6768 16.4893 14.1253 16.2502C13.59 15.9233 13.09 15.5483 12.6253 15.1252C12.2215 15.2887 11.8049 15.4137 11.3753 15.5002C10.9128 16.3407 10.3295 17.0907 9.62532 17.7502C8.08365 18.2085 7.542 17.6669 8.00032 16.1252C8.6568 15.4425 9.44847 14.9842 10.3753 14.7502C11.3318 13.661 11.4568 12.536 10.7503 11.3752C10.5637 10.5193 10.6053 9.686 10.8753 8.87522Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.959,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 23.875C18.9583 23.875 18.7917 23.875 18.625 23.875C17.4258 22.5505 16.1758 21.2589 14.875 20C15.8716 19.8753 16.8715 19.8336 17.875 19.875C17.875 18.5417 17.875 17.2083 17.875 15.875C18.5417 15.875 19.2083 15.875 19.875 15.875C19.875 17.2083 19.875 18.5417 19.875 19.875C20.8784 19.8336 21.8784 19.8753 22.875 20C21.5742 21.2589 20.3242 22.5505 19.125 23.875Z",
    fill: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewExport);
export default __webpack_public_path__ + "static/media/view-export.fb47cdefcb3e7b7fd13d3a86c58367d2.svg";
export { ForwardRef as ReactComponent };